import { FilePlus2, Users2, Handshake } from 'lucide-react'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { cn } from '@/lib/utils'

export function HowItWorks() {
  const { elementRef, isVisible } = useIntersectionObserver()

  const steps = [
    {
      number: '1',
      title: 'Crie a vaga',
      desc: 'Descreva o perfil desejado em menos de 5 minutos. É simples e direto.',
      icon: FilePlus2,
      highlight: '< 5 min',
    },
    {
      number: '2',
      title: 'Receba perfis',
      desc: 'Nossa tecnologia seleciona e te envia uma lista curta dos melhores candidatos.',
      icon: Users2,
      highlight: 'Shortlist qualificada',
    },
    {
      number: '3',
      title: 'Entrevista e contrate',
      desc: 'Converse com os favoritos e tome sua decisão com segurança e rapidez.',
      icon: Handshake,
      highlight: 'Você decide',
    },
  ]

  return (
    <section ref={elementRef} id="como-funciona" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4">
            Como funciona
          </h2>
          <p className="text-lg text-slate-600">
            Simplificamos o processo para você focar no pedagógico.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-slate-100 -z-10 transform translate-y-4"></div>

          {steps.map((step, index) => (
            <div
              key={index}
              className={cn(
                'flex flex-col items-center text-center group',
                isVisible ? 'animate-fade-in-up' : 'opacity-0',
              )}
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="w-24 h-24 rounded-full bg-white border-4 border-slate-100 flex items-center justify-center mb-6 relative z-10 group-hover:border-brand-emerald transition-colors duration-300 shadow-sm">
                <step.icon className="w-10 h-10 text-slate-400 group-hover:text-brand-emerald transition-colors" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold shadow-md">
                  {step.number}
                </div>
              </div>

              <h3 className="text-xl font-bold text-brand-navy mb-3">
                {step.title}
              </h3>
              <p className="text-slate-600 mb-4 max-w-xs">{step.desc}</p>
              <span className="text-xs font-bold uppercase tracking-wider text-brand-emerald py-1 px-3 bg-emerald-50 rounded-full">
                {step.highlight}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
